import { render } from "./UploadButton.vue?vue&type=template&id=1fe800e0"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
script.render = render

export default script